import React from "react";

const PerformanceAnalysisMultiKillCircle = (props) => {
  const { data } = props;

  return (
    <div className={`multikill-circle-and-label ${data.type}`}>
      <div className="multikill-circle">
        <div className="circle-text">{data.amount}</div>
      </div>
      <div className="multikill-text">
        <div className="colored-text">{data.type.toUpperCase()}</div>
        <div>KILLS</div>
      </div>
    </div>
  );
};

export default PerformanceAnalysisMultiKillCircle;
